/** data-coverage = wired ÷ declared inventory (FR-CAT-05) — the data-blindness board's core measure. */
export function CoverageMeter({ wired, total }: { wired: number; total: number }) {
  const pct = total ? wired / total : 0
  const fillClass = pct >= 0.8 ? 'bg-ok' : pct >= 0.5 ? 'bg-warn' : 'bg-critical'
  return (
    <div className="flex items-center gap-1.5" title="data-coverage = wired ÷ declared inventory (FR-CAT-05)">
      <div className="h-1.5 w-16 overflow-hidden rounded-full bg-border">
        <div className={`h-full ${fillClass}`} style={{ width: `${(pct * 100).toFixed(0)}%` }} />
      </div>
      <span className="mono text-[11.5px]">
        {wired}/{total}
      </span>
    </div>
  )
}
